const microServices = {
  USER_SERVICE: "/user-service/api/super-admin",
};
export const endpoints = {
  SUPER_ADMIN_SENDER_ID_LIST: `${microServices.USER_SERVICE}/campaign/sms/sender-id-approval`,
};
